{
  "booking.reserve": "Book",
  "booking.title": "Book a table",
  "common.close": "Close",
  "common.retry": "Try again",
  "common.loading": "Loading",
  "common.loadingEllipsis": "Loading…",
  "common.pageLoading": "Loading page",
  "booking.loading": "Checking availability…",
  "booking.unavailable": "Online booking is not responding at the moment.",
  "booking.slow": "This is taking a little longer. You can also call the restaurant.",
  "booking.call": "Call the restaurant",
  "nav.home": "Home",
  "nav.main": "Main navigation",
  "nav.mobile": "Mobile navigation",
  "nav.menu": "Food & drink",
  "nav.photos": "Photos",
  "nav.contact": "Find us / Contact",
  "nav.close": "Close menu",
  "nav.open": "Open menu",
  "legal.title": "Legal notice",
  "privacy.title": "Privacy policy",
  "home.restaurant": "Our restaurant",
  "home.discover": "Explore our menus",
  "hours.title": "Opening hours",
  "hours.open": "Open",
  "hours.closed": "Closed",
  "hours.today": "today",
  "newsletter.subscribe": "Subscribe",
  "newsletter.thanks": "Thank you!",
  "newsletter.email": "Your email address",
  "newsletter.placeholder": "Enter your email address",
  "menu.bodeguita": "Bodeguita menu",
  "menu.restaurant": "Restaurant menu",
  "gallery.cover": "The terrace at Le Bouddoir in the evening, under string lights",
  "gallery.title": "Our photos",
  "gallery.label": "Photo gallery",
  "gallery.close": "Close gallery",
  "gallery.previous": "Previous photo",
  "gallery.next": "Next photo",
  "gallery.error": "This photo could not be loaded.",
  "gallery.unavailable": "Photo unavailable",
  "common.pageError": "This page could not be loaded.",
  "notFound.title": "Page not found",
  "notFound.description": "The page you are looking for does not exist or has moved.",
  "notFound.home": "Back to home",
  "common.backTop": "Back to top",
  "legal.updated": "Last updated:",
  "legal.intro": "Under Article 6-III of French Law No. 2004-575 of 21 June 2004 on confidence in the digital economy, the following information identifies the publisher and hosting provider of",
  "legal.publisher": "Website publisher",
  "legal.operator": "Operating the restaurant",
  "legal.address": "Registered office:",
  "legal.siret": "Establishment SIRET number:",
  "legal.phone": "Telephone:",
  "legal.capital": "Share capital",
  "legal.vat": "EU VAT number",
  "legal.email": "Email",
  "legal.director": "Publication director",
  "legal.host": "Hosting provider",
  "legal.ipTitle": "Intellectual property",
  "legal.ip": "The text, photographs, logos and graphics on this website are protected by copyright. Any reproduction or display, in whole or in part and in any medium, requires prior written permission from",
  "legal.linksTitle": "Links to other websites",
  "legal.links": "This website links to third-party websites, including social networks and maps, whose content is outside the control of",
  "legal.linksEnd": ", which therefore cannot be held responsible for it.",
  "legal.liabilityTitle": "Liability",
  "legal.liability": "Information published on this website, particularly opening hours, menus and prices, is indicative and may change. For authoritative information, contact the restaurant on",
  "legal.liabilityEnd": ".",
  "legal.dataTitle": "Personal data",
  "legal.data": "Personal data processing, online booking and the absence of cookies are explained in the",
  "legal.privacyLink": "privacy policy",
  "legal.lawTitle": "Applicable law",
  "legal.law": "This legal notice is governed by French law. The French courts have exclusive jurisdiction.",
  "privacy.intro": "This page explains what data is collected when you visit",
  "privacy.introEnd": "and where to find details about data processing for a booking.",
  "privacy.controllerTitle": "Article 1: Who processes your data",
  "privacy.controller": "The data controller is",
  "privacy.registration": ", registered under SIREN number",
  "privacy.address": ", whose registered office is at",
  "privacy.contact": "You can contact the controller by telephone on",
  "privacy.email": ", by email at",
  "privacy.contactEnd": ", or by post at the address above.",
  "privacy.visitingTitle": "Article 2: Visiting this website",
  "privacy.visiting": "Visiting these pages involves",
  "privacy.noCollection": "no data collection",
  "privacy.noCollectionEnd": ": no accounts, forms or audience analytics.",
  "privacy.noCookies": "This website does not set any cookies",
  "privacy.noCookiesEnd": "and does not use advertising trackers. No consent banner is therefore required.",
  "privacy.thirdParties": "Three third-party services are called to display these pages and therefore receive your IP address: Google Fonts (",
  "common.and": "and",
  "privacy.fonts": ") for fonts, and jsDelivr (",
  "privacy.styles": ") for the stylesheet. They do not set cookies on this website.",
  "privacy.bookingTitle": "Article 3: Online booking",
  "privacy.booking": "Online booking, when offered on this website, is provided by a dedicated service that collects your contact details on behalf of the restaurant. The data collected, its purpose, retention periods and service providers involved are described in a notice specific to this restaurant:",
  "privacy.bookingLink": "Online booking privacy notice",
  "privacy.bookingNotice": "This notice is also available from the booking form itself. It is the authoritative source for all booking-related information. This page does not repeat it, so that there is only one version of that information.",
  "privacy.rightsTitle": "Article 4: Your rights",
  "privacy.rights": "You have the right to access, rectify and erase your personal data, restrict or object to its processing, and request data portability. You can exercise these rights by contacting the restaurant using the methods in Article 1 and providing proof of identity. You will receive a response within one month.",
  "privacy.complaint": "If you believe your rights are not being respected, you can contact the French data protection authority, the Commission nationale de l’informatique et des libertés (CNIL), at 3 place de Fontenoy, 75007 Paris, France.",
  "privacy.changesTitle": "Article 5: Changes",
  "privacy.changes": "This policy may be updated to reflect changes to the website or regulations. The date of the latest update appears at the top of this page. The publisher and hosting provider are identified in the",
  "privacy.legalLink": "legal notice",
  "menu.title": "Food & drink",
  "menu.pdfFrench": "PDF in French · opens in a new tab",
  "gallery.open": "Open photo {{number}}",
  "gallery.photo": "Photo {{number}} of our restaurant",
  "hours.closes": "closes at {{time}}",
  "hours.opens": "opens {{day}}at {{time}}",
  "legal.operating": "operating the restaurant",
  "menu.homemade": "Our food is homemade, prepared with quality ingredients.",
  "nav.skip": "Skip to content",
  "newsletter.title": "Newsletter",
  "home.slideshow": "Slideshow of the restaurant and its dishes",
  "home.slideshowList": "Photos of the restaurant",
  "home.slidePosition": "Photo {{number}} of {{total}}",
  "aboutUsEtablishmentTextFirstParagraph": "Discover the charm of South America at Le Bouddoir, our restaurant in the heart of Aix-en-Provence, opposite the iconic Altius fountain.",
  "aboutUsEtablishmentTextSecondParagraph": "Blending South American flavours with Provençal elegance, our distinctive, authentic restaurant takes you on a culinary journey.",
  "tapasTitle": "La Bodeguita",
  "tapasTextFirstPar": "Embark on a sensory journey to South America in our tapas corner. Exotic flavours, fragrant spices and a warm atmosphere.",
  "tapasSecondPar": "More than a restaurant, Le Bouddoir offers a unique dining experience in Aix-en-Provence. Our talented chef creates refined tapas showcasing local Provençal produce.",
  "descriptionCouverture": "Brunch / Tapas / Restaurant",
  "newsletterReserveTitle": "We look forward to seeing you…",
  "newsletterReserveText": "We would love to welcome you to our restaurant and introduce you to our specialities.",
  "newsletterText": "Stay up to date with our newsletter and never miss a special offer or event.",
  "cardTextFirst": "Explore our menus, bringing together authentic South American and Provençal flavours.",
  "cardTextSecond": "At Le Bouddoir in Aix-en-Provence, we passionately create dining experiences to delight your senses.",
  "infoPracticeTitle": "Good to know",
  "infoPracticePayment": "Card / Cash payments",
  "infoPracticeTicket": "Meal vouchers accepted at lunchtime only, Monday to Friday. We do not accept cheques.",
  "infoPracticePrices": "All prices include tax and service",
  "altCouverture": "The Bodeguita room at Le Bouddoir: neon sign, painted mural and green banquettes",
  "altAboutUs": "The dining room at Le Bouddoir, laid for service in daylight",
  "altTapas": "An assortment of fried tapas served on a wooden board",
  "altCardSection": "Grilled steak plated with its vegetables",
  "altInfoPractice": "Beer taps at Le Bouddoir bar",
  "altCardMenuCover": "A cut of beef searing over the charcoal grill",
  "legalCompanyForm": "simplified joint-stock company (SAS)",
  "legalHostCountry": "United States",
  "servesCuisine": [
    "Tapas",
    "South American cuisine",
    "Brunch",
    "Cocktails"
  ]
}
